import styled from 'styled-components';

export const Content = styled.div`
  color: #000;
  background-color: transparent !important;
  background-position: left center;
  background-repeat: no-repeat;
  min-height: 100%;
  height: 100%;
  max-width: 297mm;
`;

export const Barra = styled.div`
  width: 100%;
  height: 22px;
  background-color: #404b51;
`;

export const Footer = styled.div`
  position: relative;
  bottom: 0;
  font-size: 0.9rem;

  h2 {
    font-size: 20px;
    text-transform: capitalize;
    font-weight: bold;
    margin-bottom: 1px;
  }

  p {
    margin-bottom: 0;
  }

  @media print {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
`;

export const FooterBackGround = styled.div`
  height: 110px;
  background-color: #404b51;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const DadosClinica = styled.div`
  margin-left: 75px;
  margin-top: 0.25rem;
  color: #fff;

  @media print {
    margin-left: 45px;
  }
`;

export const BordaTelefone = styled.div`
  width: 22px;
  height: 22px;
  border: 1px solid #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
